'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class; // Lib


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _ColumnPresentationalWrapper = require('./ColumnPresentationalWrapper');

var _ColumnPresentationalWrapper2 = _interopRequireDefault(_ColumnPresentationalWrapper);

var _elementLineEdgeDropTarget = require('../line/elementLineEdgeDropTarget');

var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColumnContainer = (0, _elementLineEdgeDropTarget2.default)(_class = function (_React$Component) {
    _inherits(ColumnContainer, _React$Component);

    function ColumnContainer() {
        _classCallCheck(this, ColumnContainer);

        return _possibleConstructorReturn(this, (ColumnContainer.__proto__ || Object.getPrototypeOf(ColumnContainer)).apply(this, arguments));
    }

    _createClass(ColumnContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                connectLineEdgeDropTarget = _props.connectLineEdgeDropTarget,
                inList = _props.inList;


            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;

            return lineEdgeConnector(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_ColumnPresentationalWrapper2.default, this.props)
            ));
        }
    }]);

    return ColumnContainer;
}(_react2.default.Component)) || _class;

exports.default = ColumnContainer;


ColumnContainer.propTypes = {
    element: _propTypes2.default.object.isRequired,
    children: _propTypes2.default.array,
    currentBoardId: _propTypes2.default.string,
    connectDropTarget: _propTypes2.default.func,
    connectLineEdgeDropTarget: _propTypes2.default.func,
    isHovered: _propTypes2.default.bool,
    isPresentational: _propTypes2.default.bool,
    inList: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/column/ColumnContainer.js
// module id = 1963
// module chunks = 0